var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHash = function SvgHash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "#fff",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9h14M5 15h14M11 4L7 20M17 4l-4 16"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNmZmZmZmYiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+CiAgPGxpbmUgeDE9IjUiIHkxPSI5IiB4Mj0iMTkiIHkyPSI5IiAvPgogIDxsaW5lIHgxPSI1IiB5MT0iMTUiIHgyPSIxOSIgeTI9IjE1IiAvPgogIDxsaW5lIHgxPSIxMSIgeTE9IjQiIHgyPSI3IiB5Mj0iMjAiIC8+CiAgPGxpbmUgeDE9IjE3IiB5MT0iNCIgeDI9IjEzIiB5Mj0iMjAiIC8+Cjwvc3ZnPg==";
export { SvgHash as ReactComponent };